import { render, staticRenderFns } from "./CommonLoginNew.vue?vue&type=template&id=708d89ef&scoped=true"
import script from "./CommonLoginNew.vue?vue&type=script&lang=js"
export * from "./CommonLoginNew.vue?vue&type=script&lang=js"
import style0 from "./CommonLoginNew.vue?vue&type=style&index=0&id=708d89ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d89ef",
  null
  
)

export default component.exports